import { useEffect, useState, useMemo } from 'react';
import {
  Grid,
  Button,
  Dialog,
  Typography,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './reportsAnalytics.css';
import close from '../../asset/image/cross.svg';
import clock from '../../asset/image/mingcute_time-line.svg';
import _ from 'lodash';
import { toast } from 'react-toastify';
import CustomLoader from '../Loader/CustomLoader';
import moment from 'moment';
import NetworkTable, {
  ColumnType,
  NetworkTableRow,
} from '../../UserScreen/InventoryPage/InventorySettings/components/InterfacesTable/NetworkTable/NetworkTable';
import {
  getReportsSubscription,
  deleteSubscriptionReport,
  createReportsSubscription,
} from '../../actions/Users/authenticateUsageReports';
import {
  getChildrenDpList,
  setDateTimeByTimezone,
  formatRecurringDateUnit,
} from '../../utils/util';
import {
  DEFAULT_SITE_REPORT_TYPES,
  DEFAULT_SL_REPORT_TYPES,
  DEFAULT_FREQUENCIES,
  DEFAULT_SCHEDULER_REPORT_TYPES,
} from '../../constants/Constants';
import { CONFIRM_DIALOG_TITLE } from '../../config';
import ConfirmDialog from '../ConfirmDialog';
import AddReportPopup from '../SubscriptionReports/ReportPopup/AddReportPopup';

const Headers = [
  {
    label: 'Report Name',
    key: '_name',
    sortKey: 'name',
    sortable: true,
    formatPlain: true,
    type: ColumnType.splitColumnWithImage,
    splitColumnBy: '\n',
    maxWidth: '120px',
  },
  {
    label: 'Frequency',
    key: '_frequency',
    sortKey: 'frequency',
    sortable: true,
    type: ColumnType.text,
    maxWidth: '100px',
  },
  {
    label: 'Next Run',
    key: 'next_run_at',
    sortKey: 'next_run_at',
    sortable: true,
    type: ColumnType.splitColumn,
    splitColumnBy: '\n',
    maxWidth: '100px',
  },

  {
    label: 'Actions',
    key: 'custom',
    type: ColumnType.actions,
    actions: ['edit', 'runNow', 'delete'],
    maxWidth: '82px',
  },
];

const ConfigListPopup = (props) => {
  const {
    open,
    onClose,
    reports,
    total_count,
    newSummaryStartDate,
    newSummaryEndDate,
    getReportsSubscription,
    location,
    authReducer,
    deleteSubscriptionReport,
    site_admin_access,
    sl_admin_access,
    showAllServiceLines = false,
    getAllServiceLinesSubscription,
    sel_dps,
    createReportsSubscription,
  } = props;
  const [policy, setPolicy] = useState(
    site_admin_access && !sl_admin_access
      ? 'onlySite'
      : !site_admin_access && sl_admin_access
        ? 'onlyStarlink'
        : 'all',
  );

  const [selected_dps, setSelectedDps] = useState<any>([]);
  const [showLoader, setShowLoader] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    onConfirm: {},
  });
  const [tableParams, setTableParams] = useState<{
    page: number;
    size: number;
    sortBy: string;
    sortOrder: string;
    search: string;
  }>({
    page: 1,
    size: 10,
    sortBy: 'created_at',
    sortOrder: 'desc',
    search: '',
  });
  const [addReportPopup, setAddReportPopup] = useState(false);
  const [result, setResult] = useState<any>([]);
  const [report_edit, setReportEdit] = useState<any>(null);
  const [report_type_list, setReportTypeList] = useState<any>(
    policy == 'onlySite'
      ? [...DEFAULT_SITE_REPORT_TYPES]
      : policy == 'onlyStarlink'
        ? [...DEFAULT_SL_REPORT_TYPES]
        : [...DEFAULT_SCHEDULER_REPORT_TYPES],
  );
  const [_sitesList, setSitesList] = useState<any>([]);
  const [serviceLineName, setServiceLineName] = useState<any[]>([]);
  const [serviceLines, setServiceLines] = useState<any>([
    { name: 'All Service Lines', id: 'All Service Lines' },
  ]);
  const today_date = moment(new Date()).utc();

  useEffect(() => {
    if (sel_dps && sel_dps.length) setSelectedDps([...sel_dps]);
  }, [sel_dps]);

  useEffect(() => {
    if (
      !_.isEmpty(authReducer.selectedOu) &&
      authReducer.selectedOu.hasOwnProperty('id') &&
      authReducer.selectedOu.id &&
      selected_dps?.length
    ) {
      callSchedulerListAPI();
    }
  }, [selected_dps, newSummaryStartDate, newSummaryEndDate, tableParams]);

  useEffect(() => {
    let new_result: any[] = [];
    if (authReducer?.getOrganisationUnitList?.dps?.length && reports?.length) {
      reports.map((row) => {
        let org_ids = row.orgs_id;
        // if (!org_ids.some((org) => org === row.org_id))
        //   org_ids.push(row.org_id);
        let org_list: any = {};
        org_list = fn_list_dps(
          authReducer.getOrganisationUnitList.dps,
          org_ids,
        );
        let nxt_rn_at: any = '-';
        if (row?.next_run_at && row?.report_timezone) {
          let timezone = row.report_timezone.split(' - ')[0];
          let time_zn_label = row.report_timezone.split(' - ')[1];
          let dte = moment(row.next_run_at).tz(timezone);
          nxt_rn_at =
            moment(dte).format('MMM DD, YYYY HH:mm') + ' ' + time_zn_label;
        }
        new_result.push({
          ...row,
          org_names: org_list.org_list,
          dps_list: org_list.dps_list,
          next_run_at: nxt_rn_at,
          _name: row.name + '\n' + row.requested_by,
          splitImageName: 'clockblueborder',
          _frequency:
            row?.frequency?.[0] !== 'One-Time' &&
            row?.frequency?.[0] !== 'Daily'
              ? row.frequency[0] +
                ` (${formatRecurringDateUnit(row?.frequency?.[0].toLowerCase(), row.schedule_day)})`
              : row.frequency,
        });
      });
    }
    setResult(new_result);
    setShowLoader(false);
  }, [reports]);

  useEffect(() => {
    if (_.isEmpty(authReducer?.getVesselsListing)) return;

    // Clone the vessels array to avoid mutating Redux state
    const vesselsFromStore = authReducer?.getVesselsListing?.locations || [];
    const vessels: { name: string; id: string }[] = [...vesselsFromStore];

    if (!vessels.some((vsl) => vsl.name === 'All Sites')) {
      vessels.unshift({ name: 'All Sites', id: 'All Sites' });
    }
    setSitesList(vessels);
  }, [authReducer?.getVesselsListing, authReducer?.filteredVessels]);

  useEffect(() => {
    if (!_.isEmpty(authReducer?.fetchServiceLines)) {
      let serviceLinesData = Object.assign(
        authReducer.fetchServiceLines?.serviceLines,
      );
      let externalAllServiceLineObj = {
        name: 'All Service Lines',
        id: 'All Service Lines',
      };
      if (
        !serviceLinesData.some(
          (serviceLine) => serviceLine.name === 'All Service Lines',
        )
      ) {
        serviceLinesData.unshift(externalAllServiceLineObj);
        setServiceLines([externalAllServiceLineObj]);
      }
      setServiceLineName(serviceLinesData);
    }
  }, [authReducer.fetchServiceLines]);

  useEffect(() => {
    if (
      authReducer.fetchServiceLines &&
      authReducer.fetchServiceLines.serviceLines &&
      getAllServiceLinesSubscription
    ) {
      let serviceLines = authReducer.fetchServiceLines.serviceLines;
      let filteredServiceLines = serviceLines;
      if (!showAllServiceLines) {
        filteredServiceLines = serviceLines.filter((line) =>
          getAllServiceLinesSubscription.some(
            (sub) => sub.service_line_number === line.id && sub.active,
          ),
        );
      }

      if (
        !filteredServiceLines.some(
          (serviceLine) => serviceLine.name === 'All Service Lines',
        )
      ) {
        let externalAllServiceLineObj = {
          name: 'All Service Lines',
          id: 'All Service Lines',
          is_all: true,
        };
        filteredServiceLines.unshift(externalAllServiceLineObj);
        setServiceLines([externalAllServiceLineObj]);
      }
      setServiceLineName(filteredServiceLines);
    }
  }, [
    authReducer.fetchServiceLines,
    getAllServiceLinesSubscription,
    showAllServiceLines,
  ]);

  function fn_list_dps(dp_list, org_ids) {
    let resp: any = {};
    let org_list: string[] = [];
    let dps_list: any[] = [];
    dp_list.map((dp) => {
      if (org_ids.includes(dp.id)) {
        org_list.push(dp.name);
        dps_list.push(dp);
      }
      if (dp?.parent_of?.length) {
        let dpss = fn_list_dps(dp.parent_of, org_ids);
        org_list.push(...dpss.org_list);
        dps_list.push(...dpss.dps_list);
      }
    });
    resp = { org_list: org_list, dps_list: dps_list };
    return resp;
  }

  const callSchedulerListAPI = async () => {
    setShowLoader(true);
    let report_type = [...report_type_list];
    report_type = report_type.filter((type) => type.label !== 'All');
    let _type: string[] = [];
    if (report_type.length) {
      report_type.map((type) => _type.push(type.label));
    }

    let freqency = [...DEFAULT_FREQUENCIES];
    freqency = freqency.filter((freq) => freq.label !== 'All');
    let _frequency: string[] = [];
    if (freqency.length) {
      freqency.map((type) => _frequency.push(type.label));
    }

    let _sites: string[] = [];
    let _service_line: string[] = [];
    let payload = {
      //org_id: dpId,
      orgs_id: selected_dps,
      from_date: moment(newSummaryStartDate).format('YYYY-MM-DD'),
      to_date: moment(newSummaryEndDate).format('YYYY-MM-DD'),
      sort_by: tableParams.sortBy,
      sort_order: tableParams.sortOrder,
      type: _type,
      frequency: [], // update this with _frequency when more than 1 is avl
      service_lines_id: _service_line,
      sites_id: _sites,
      page: tableParams.page,
      size: tableParams.size,
      policy: policy,
    };
    getReportsSubscription(payload);
  };

  const handleSorting = (sorting: any) => {
    let sort_order = tableParams.sortOrder == 'asc' ? 'desc' : 'asc';
    let sort_obj = Headers.find((head) => head.key === sorting);
    let sort_by: any = sort_obj?.sortKey ?? sorting;

    setTableParams({ ...tableParams, sortOrder: sort_order, sortBy: sort_by });
  };

  const handlePagination = (newpage, limit) => {
    setTableParams({ ...tableParams, page: newpage, size: limit });
  };

  const handlePerPageChange = (limit) => {
    setTableParams({ ...tableParams, size: limit, page: 1 });
  };

  const handleDeleteConfirm = async (toDeleteReport) => {
    if (toDeleteReport) {
      let _toDeleteReport = toDeleteReport;
      let resp = await deleteSubscriptionReport(_toDeleteReport.id);
      if (resp?.success)
        toast.success(resp.result, { position: toast.POSITION.BOTTOM_LEFT });
      setTableParams({ ...tableParams, page: tableParams.page });
      // if (!call_scheduled_report)
      //   dispatch({ type: CALL_SCHEDULED_REPORT, payload: true });
    }
  };

  const handleAddPopupClick = () => {
    setAddReportPopup(true);
  };

  const handleClosePopup = (e, call_list_api = false, toast_msg = null) => {
    setAddReportPopup(false);
    setReportEdit(null);
    if (call_list_api) {
      toast.success(toast_msg, { position: toast.POSITION.BOTTOM_LEFT });
      setTableParams({ ...tableParams, page: tableParams.page });
    }
  };

  const handleEditReportPopup = (row, cpy_report = false) => {
    let _type: any[] = [];
    let _report_types = [...report_type_list];
    _report_types = _report_types.filter((type) => type.name !== 'All');
    if (
      _report_types?.length > 0 &&
      row?.type?.length > 0 &&
      _report_types.length === row.type.length
    ) {
      _type = [...report_type_list];
    } else {
      row.type.map((type) => {
        let rep_type = report_type_list.find(
          (rep) => rep.label.toLowerCase() === type.toLowerCase(),
        );
        if (rep_type) _type.push(rep_type);
      });
    }
    row._type = _type;
    let _freq: any[] = [];
    row.frequency.map((type) => {
      let freq = DEFAULT_FREQUENCIES.find(
        (rep) => rep.label.toLowerCase() === type.toLowerCase(),
      );
      if (freq) _freq.push(freq);
    });
    row._freq = _freq;

    let _sline: any[] = [];
    if (row?.service_lines_id?.length) {
      row.service_lines_id.map((sl_id) => {
        let sl = serviceLineName.find((rep) => rep.id === sl_id);
        if (sl) _sline.push({ serviceLineName: sl.name, serviceLineId: sl_id });
      });
    }
    row._sline = _sline;

    let _site: any[] = [];
    if (row?.sites_id?.length) {
      row.sites_id.map((site_id) => {
        let vsl = _sitesList.find((rep) => rep.id === site_id);
        if (vsl) _site.push({ siteName: vsl.name, siteId: site_id });
      });
    }

    row._site = _site;

    setAddReportPopup(true);
    // if (cpy_report) setCopyReport(true);
    setReportEdit(row);
  };

  const handleRunNow = (row) => {
    const frequency = row?.frequency?.[0] ?? null;

    if (!frequency) return;

    if (frequency === 'One-Time') {
      toast.error(`Run Now is not available for One-Time Reports`, {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      return;
    }

    const timezone = authReducer?.userTimezone
      ? authReducer.userTimezone.split(' - ')[0]
      : 'UTC';

    const current_time = setDateTimeByTimezone(today_date, timezone);
    const normalizedFrequency = frequency.toLowerCase();
    const from_date = getFromDate(normalizedFrequency, current_time);
    const fromDateTz = setDateTimeByTimezone(from_date, timezone);
    const fromFormatted = fromDateTz.format('DD-MMM-YYYY HH:mm:ss');
    const toFormatted = current_time.format('DD-MMM-YYYY HH:mm:ss');
    const report_name = `${row.name}-${current_time.format('DD-MMM-YYYY-HH-mm-ss')}`;
    const reportPayload = {
      name: report_name,
      from_date: fromDateTz.utc().format(),
      to_date: current_time.utc().format(),
    };

    const onConfirm = () => handleRunNowReport(row, reportPayload);
    setConfirmDialog({
      isOpen: true,
      title: CONFIRM_DIALOG_TITLE,
      subTitle: `Do you want to Run Now the Report Scheduler ${report_name} from ${fromFormatted} to ${toFormatted}?`,
      onConfirm,
    });
  };

  const handleRunNowReport = async (
    row,
    reportPayloadBase: { name: string; from_date: string; to_date: string },
  ) => {
    setShowLoader(true);
    try {
      const payload = {
        ...reportPayloadBase,
        parent_config_id: row.id,
        sites_id: [...(row.sites_id || [])],
        service_lines_id: [...(row.service_lines_id || [])],
        description: row.description,
        category: 'OnDemand',
        types: [...(row.type || [])],
        orgs_id: [...(row.orgs_id || [])],
        scope: row.scope,
        report_timezone: row.report_timezone,
      };
      const response = await createReportsSubscription(payload);
      let shouldRefreshList = false;
      let toastMessage: string | null = null;
      if (response?.success === true) {
        shouldRefreshList = true;
        toastMessage = `Report ${reportPayloadBase.name} successfully `;
      }
      if (onClose) onClose({}, shouldRefreshList, toastMessage);
    } catch (_error) {
      // prevent loader from getting stuck on API failure
    } finally {
      setShowLoader(false);
    }
  };

  function getFromDate(unit, toDate) {
    const date = new Date(toDate);
    if (isNaN(date.getTime())) return toDate;

    switch (unit) {
      case 'daily':
        date.setDate(date.getDate() - 1);
        break;

      case 'weekly':
        date.setDate(date.getDate() - 1 * 7);
        break;

      case 'monthly':
        date.setMonth(date.getMonth() - 1);
        break;

      default:
        return toDate;
    }

    return date;
  }

  const handleActionClick = (
    type: 'delete' | 'edit' | 'runNow',
    headerKey: string,
    row: NetworkTableRow,
  ) => {
    switch (type) {
      case 'delete':
        setConfirmDialog({
          isOpen: true,
          title: CONFIRM_DIALOG_TITLE,
          subTitle: `Do you want to delete the Report Scheduler ${row.name}?`,
          onConfirm: () => {
            handleDeleteConfirm(row);
          },
        });
        break;
      case 'edit':
        handleEditReportPopup(row);
        break;
      case 'runNow':
        handleRunNow(row);
        break;
      default:
        break;
    }
  };

  return (
    <Dialog
      className='menuScroll'
      onClose={onClose}
      open={open}
      fullWidth
      maxWidth='md'
    >
      <DialogTitle className='invite-user-padding dialog_title'>
        <Grid item container className='inter-font dialog_grid'>
          <div className='dialog-report-title'>
            <Typography className='title-text'>Scheduled Reports</Typography>
            <Typography>
              Manage your recurring report schedules and distributions.
            </Typography>
          </div>
          <Grid style={{ marginLeft: 'auto' }}>
            <img src={close} onClick={onClose} className='image-style' />
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent className='dialog-config_content'>
        <NetworkTable
          data={result}
          columns={Headers}
          sortBy={tableParams.sortBy}
          sortOrder={tableParams.sortOrder}
          enablePagination={true}
          rowsPerPageOptions={[10, 15, 25]}
          defaultRowsPerPage={10}
          headingHeight={40}
          maxHeight={`calc(100vh - 320px)`}
          totalRowCount={total_count}
          onPageChange={handlePagination}
          onRowsPerPageChange={handlePerPageChange}
          page={tableParams.page}
          rowsPerPage={tableParams.size}
          onSortChange={handleSorting}
          onActionClick={handleActionClick}
        />
      </DialogContent>
      <DialogActions className='config-create-actions'>
        <Grid container spacing={2} className='dialog-action-box'>
          {/* TODO: Available in next report release
          <Grid item className='dialog-action-txt'>
            <Typography>
              Scheduled reports are automatically emailed to recipients upon
              generation.
            </Typography>
          </Grid>
          */}
          <Grid item className='dialog-action-btns'>
            <Button
              className='config-cancel-btn'
              onClick={onClose}
              variant='outlined'
            >
              Close
            </Button>
            <Button
              className='config-create-btn button_style button-style'
              onClick={handleAddPopupClick}
            >
              <img
                src={clock}
                alt='setting'
                style={{ display: 'block', marginRight: '5px' }}
                width='18'
                height='18'
                color='#fff'
              />
              <Typography className='btn-new-schedule-txt'>
                Create New Schedule
              </Typography>
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
      {addReportPopup && (
        <AddReportPopup
          open={addReportPopup}
          onClose={(e, is_api, toast_msg) => {
            handleClosePopup(e, is_api, toast_msg);
          }}
          is_report_edit={report_edit}
          is_copy_report={false}
        />
      )}
      {showLoader && (
        <CustomLoader showLoader={true} loadingText={'Please wait...'} />
      )}
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
    </Dialog>
  );
};

const mapStateToProps = (state) => ({
  authReducer: state.authReducer,
  errorReducer: state.errorReducer,
  newSummaryStartDate: state.authReducer.newSummaryStartDate,
  newSummaryEndDate: state.authReducer.newSummaryEndDate,
  reports: state.authReducer.getSubscriptionReportsTable,
  total_count: state.authReducer.getSubscriptionReportsTableCount,
  site_admin_access: state?.authReducer?.site_admin_access,
  sl_admin_access: state?.authReducer?.sl_admin_access,
});

export default withRouter(
  connect(mapStateToProps, {
    getReportsSubscription,
    deleteSubscriptionReport,
    createReportsSubscription,
  })(ConfigListPopup),
);
